import { render, staticRenderFns } from "./imgLoading.vue?vue&type=template&id=66875b3c&scoped=true&"
import script from "./imgLoading.vue?vue&type=script&lang=js&"
export * from "./imgLoading.vue?vue&type=script&lang=js&"
import style0 from "./imgLoading.vue?vue&type=style&index=0&id=66875b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66875b3c",
  null
  
)

export default component.exports